import { axios } from 'lib';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

const recordOutcome = ({ jobAdID, outcome }) => {
  try {
    return axios.put(
      `/api/job_ads/${jobAdID}/outcome`,
      JSON.stringify({ outcome: outcome })
    );
  } catch (error) {
    return error;
  }
};

export const useRecordOutcome = () => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: recordOutcome,
    onSuccess: () => {
      enqueueSnackbar('Outcome recorded successfully', {
        variant: 'success',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });
    },
    onError: (error) => {
      console.log(error);
      enqueueSnackbar(error?.message || 'Failed to record outcome', { variant: 'error' });
    },
  });
};
